<template>
  <section class="bg-slate-50 dark:bg-slate-800 md:py-24 pt-36 sm:pt-28 pb-16">
    <div class="container mt-10">
      <div class="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
        <div class="lg:col-span-8 md:col-span-6">
          <div class="md:flex items-center p-6 shadow dark:shadow-gray-700 rounded-md bg-white dark:bg-slate-900 mb-6">
            <div class="company-info flex items-center">
                <div class="w-20 h-20 text-white shadow dark:shadow-gray-700 flex items-center justify-center"
                    :class="{'bg-gradient': !data?.company?.logoUrl}">
                  <i v-if="!data?.company?.logoUrl" class="uil uil-building text-[28px]"></i>
                  <router-link v-else :to="{name: 'Company', params: {slug: data?.company?.slug}}">
                    <img :src="data.company.logoUrl" alt="Company Logo" class=" w-full h-full"/>
                  </router-link>
                </div>
            </div>
            <div class="md:ms-4 md:mt-0 mt-6">
              <h5 class="text-xl font-semibold">
                {{ data?.title ? data.title : 'Job Title Not Available' }} </h5>
              <div class="mt-2">
                <span class="font-medium me-2 inline-block">
                  <i class="uil uil-building text-[18px] text-primary-color me-1"></i>
                  <router-link v-if="data?.company?.slug" :to="{name: 'Company', params: {slug: data?.company?.slug}}">
                  {{ data?.company?.name ? data.company.name : 'Company Name Not Available' }}
                  </router-link>
                </span> <span class="font-medium me-2 inline-block">
                  <i class="uil uil-map-marker text-[18px] text-primary-color me-1"></i>
                  {{ data?.location?.name ? data.location.name : 'Location Not Available' }}
                </span>
              </div>
            </div>
          </div>

          <div class="p-6 shadow dark:shadow-gray-700 rounded-md bg-white dark:bg-slate-900">
            <h5 class="text-lg font-semibold">{{ $t('job.detail.title') }}:</h5>
            <ul
              class="p-class mt-4 overflow-hidden"
              :class="data?.desFormatted === false ? 'whitespace-pre-wrap' : 'whitespace-normal'"
              v-html="decodedDescription">
            </ul>

            <div class="mt-5">
              <GlassButton
                text="Jetzt bewerben"
                @click="handleApplyNow"
              />
            </div>
          </div>
        </div>

        <div class="lg:col-span-4 md:col-span-6">
          <div class="mb-6" v-if="data">
            <JobDetailSidebar :job="data"/>
          </div>

          <div class="shadow dark:shadow-gray-700 border-gradient rounded-md bg-white dark:bg-slate-900">
            <div class="p-6">
              <h5 class="text-xl font-semibold">KI Suchagent</h5>
            </div>

            <div class="px-6 pb-6 border-t border-slate-100 dark:border-t-gray-700">
              <div class="flex flex-col items-center">
                <img src="@/assets/images/job/fox3d.png" alt="img" width="176" height="176" />
                <p class="text-slate-700 dark:text-slate-400 xl:px-3 mt-1 mb-4">Möchtest über ähnliche Jobs informiert werden? Dann beauftrage jetzt den Fuchsjobs KI Suchagenten!</p>
                <GlassButton
                    text="KI Suchagent"
                    @click="$router.push({ name: 'CandidateJobAlert' })"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style scoped>
.text-slate-400 ul {
  list-style-type: disc;
  padding-left: 1.25rem;
}
ul {
  list-style: circle !important;
}
</style>
<script>
import JobService from '@/services/job.service'
import JobDetailSidebar from '@/components/job/detail/JobDetailSidebar.vue'
import GlassButton from '@/components/utility/GlassButton.vue'
import CandidateService from '@/services/candidate.service'
import { getLoginStatus } from '@/events/useGlobalState';

export default {
  data () {
    return {
      data: null,
      id: '',
    }
  },
  components: {
    JobDetailSidebar,
    GlassButton,
  },
  mounted () {
    this.slug = this.$route.params.slug
    this.fetchJobDetails(this.slug)
  },
  computed: {
    decodedDescription() {
      return this.decodeHtmlEntities(this.data?.description || '');
    }
  },
  methods: {
    async fetchJobDetails (slug) {
      try {
        const response = await JobService.getJobBySlug(slug)
        this.data = response.data
        console.log(this.data)
      } catch (error) {
        console.error('Error fetching job details:', error)
      }
    },
    async handleApplyNow() {
      try {
        if (getLoginStatus()) {
          await CandidateService.candidateViewJob(this.data.id);
        }
        if (!this.data.createdBy) {
          if (this.data.externalUrl) {
            window.open(this.data.externalUrl, '_blank', 'noopener,noreferrer');
          }
          return;
        }

        // Internal job
        if (this.data.createdBy) {
          if (!getLoginStatus()) {
            localStorage.setItem('redirect_url', this.$router.currentRoute.value.path);
            this.$router.push({ name: 'userLogin' });
            return;
          }
          await CandidateService.candidateApplyJob(this.data.id);
        }
      } catch (error) {
        console.error(`Failed to process job:`, error);
      }
    },
    decodeHtmlEntities(str) {
      const txt = document.createElement('textarea');
      txt.innerHTML = str;
      return txt.value;
    }
  },
}
</script>

